/* eslint-disable jsx-a11y/anchor-is-valid, no-param-reassign, max-len */
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'underscore';
import PropTypes from 'prop-types';
import $ from 'jquery';
import classnames from 'classnames';
import { AdStrengthSuggestionRepository } from './rsa-ad-strength-suggestion-repository';
import { ViewSuggestionType } from './ad-strength-helper';

import { viewSuggestionMeasurement,
  applySuggestionMeasurement,
  returnSuggestionMeasurement,
  isViewSuggestionApplied,
  containerExists } from './rsa-ad-strength-suggestion-helper';

export class AdStrengthSuggestionPicker extends React.Component {
  static defaultProps = {
    itemsToDisplay: [],
    container: $(document.body),
  };

  getDisplayPosition(target, container) {
    const $target = $(target);
    const targetOffset = $target.offset();
    const containerOffset = container.offset();

    // Calculate the position of the popup relative to the container.
    // The container needs to be non-statically positioned, either fixed, relative or absolute,
    // because the popup is position: absolute.
    return {
      top: (targetOffset.top - containerOffset.top) + $target.outerHeight(),
      left: targetOffset.left - containerOffset.left,
    };
  }

  addAssetSuggestion(event, target, description, suggestionId) {
    const { viewModel, pickerContainer } = this.props;
    if (!_.isEmpty(target)) {
      viewModel[target.name](description);
      if (!_.isEmpty(suggestionId)) {
        applySuggestionMeasurement(viewModel, suggestionId);
      }
    }
    event.stopPropagation();
    event.preventDefault();
    // Hide picker
    ReactDOM.unmountComponentAtNode(pickerContainer);
  }

  render() {
    const {
      container, i18n, target, itemsToDisplay, assetType,
    } = this.props;

    const position = this.getDisplayPosition(target, container);

    const containerStyle = {
      display: 'block', left: `${position.left}px`, top: `${position.top}px`, zIndex: 1001,
    };

    const pickerTitle = assetType === ViewSuggestionType.Headline ?
      i18n.getString('Ad_Strength_Suggestion_Picker_Title_Headline') :
      i18n.getString('Ad_Strength_Suggestion_Picker_Title_Description');

    let contentView = null;
    const contentClasses = ['picker-list'];
    contentView = itemsToDisplay.map(({ SuggestionId, Asset }, index) => (
      <li>
        <a
          role="menuitem"
          arial-label={Asset}
          href="#"
          onClick={event => this.addAssetSuggestion(event, target, Asset, SuggestionId)}
          key={SuggestionId}
          data-index={index}
        >
          { Asset ? <div className="type-normal">{Asset}</div> : null}
        </a>
      </li>), this);

    // The title in picker needs a specific style.
    const pickerTitleStyle = { padding: '10px 10px 3px 10px', 'font-weight': 'bold' };
    return (
      <ul className={classnames('dropdown-menu', ...contentClasses)} role="menu" style={containerStyle}>
        <li className="ad-strength-suggestion-picker-title" style={pickerTitleStyle}>
          {pickerTitle}
        </li>
        {contentView}
      </ul>
    );
  }
}

AdStrengthSuggestionPicker.propTypes = {
  itemsToDisplay: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
  })),
  target: PropTypes.shape({}).isRequired,
  container: PropTypes.shape({ offset: PropTypes.func }),
  pickerContainer: PropTypes.objectOf(PropTypes.any).isRequired,
  viewModel: PropTypes.objectOf(PropTypes.any).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  assetType: PropTypes.string.isRequired,
};

export class AdStrengthSuggestionController {
  constructor({
    container,
    appState,
    token,
    odataPath,
    i18n,
  }) {
    this.container = container;
    this.appState = appState;
    this.token = token;
    this.odataPath = odataPath;
    this.i18n = i18n;
    this.cachedSuggestions = [];
    this.cachedAdGroupId = -1;
    this.cachedFinalUrl = null;
  }

  keydown(event) {
    switch (event.key) {
      case 'Escape':
        this.hidePicker();
        break;
      default:
        break;
    }
  }

  updateDisplayPosition(target) {
    const $target = $(target);
    const targetOffset = $target.offset();
    const containerOffset = this.container.offset();
    $('.dropdown-menu.picker-list').css('top', `${(targetOffset.top - containerOffset.top) + $target.outerHeight()}px`);
  }

  handelScroll(target) {
    const existingPickerContainer = $('.dropdown-menu.picker-list');
    const header = $('.sticky-header.table-bordered');
    const focused = $(':focus');
    if (containerExists(existingPickerContainer) && containerExists(header) && containerExists(focused)) {
      this.updateDisplayPosition(target);
      if (existingPickerContainer[0].getBoundingClientRect().top < header[0].getBoundingClientRect().bottom) {
        this.hidePicker();
        focused[0].blur();
      }
    }
  }

  registerGlobalEvents(target) {
    $('.recommend-ad-editor-panel').on('click', event => this.clickedAway(event));
    $('.recommendation-grid-page').on('scroll', () => this.handelScroll(target));
    $(target).on('keydown', event => this.keydown(event));
  }

  hidePicker() {
    const existingPickerContainer = $('.ad-strength-suggestion-container');
    if (containerExists(existingPickerContainer)) {
      ReactDOM.unmountComponentAtNode(_.first(existingPickerContainer));
    }
    $('.ad-strength-suggestion-container').remove();
    $('.recommend-ad-editor-panel').off('click');
    $('.recommendation-grid-page').off('scroll', this.handelScroll);
    $(this.target).off('keydown', this.keydown);
  }

  clickedAway(event) {
    const target = $(event.target);
    if (target.closest('.ad-strength-suggestion-helper-area').length === 0 &&
      target.closest('.ad-strength-suggestion-container').length === 0) {
      this.hidePicker();
    }
  }

  renderPicker(target, suggestions, viewModel, assetType) {
    const { container, i18n } = this;
    if (!containerExists($('.ad-strength-suggestion-container'))) {
      const containerToUse = $('<div class="ad-strength-suggestion-container open"/>');
      containerToUse.appendTo(container);
    }
    const existingPickerContainer = $('.ad-strength-suggestion-container');
    if (!_.isEmpty(suggestions) && containerExists(existingPickerContainer)) {
      const pickerContainer = _.first(existingPickerContainer);
      // render latest picker
      ReactDOM.render(React.createElement(AdStrengthSuggestionPicker, {
        itemsToDisplay: suggestions,
        target,
        container,
        pickerContainer,
        viewModel,
        i18n,
        assetType,
      }), pickerContainer);
      this.registerGlobalEvents(target);
    } else {
      this.hidePicker();
    }
  }

  isSuggestionCached(adGroupId, finalUrl) {
    const {
      cachedAdGroupId, cachedFinalUrl,
    } = this;

    return (cachedAdGroupId !== -1 && !_.isEmpty(cachedFinalUrl)
      && cachedAdGroupId === adGroupId && finalUrl === cachedFinalUrl);
  }

  filterSuggestion(viewModel, assetType, input) {
    const viewSuggestionIds = [];
    const returnSuggestionIds = [];
    const filteredSuggestions = _.filter(this.cachedSuggestions, (suggestion) => {
      returnSuggestionIds.push(suggestion.SuggestionId);
      if (suggestion.AssetType.toLowerCase() !== assetType || _.isEmpty(suggestion.Asset)) {
        return false;
      }
      const suggestionContent = suggestion.Asset.toLowerCase();
      // If the input field is not empty, provide suggestions which start with the inputted text.
      if (!_.isEmpty(input) && !suggestionContent.startsWith(input.toLowerCase())) {
        return false;
      }

      const isViewSuggestionNotApplied =
        !isViewSuggestionApplied(viewModel, assetType, suggestionContent);

      if (isViewSuggestionNotApplied) {
        viewSuggestionIds.push(suggestion.SuggestionId);
      }
      return isViewSuggestionNotApplied;
    });
    viewSuggestionMeasurement(viewModel, viewSuggestionIds);
    returnSuggestionMeasurement(viewModel, returnSuggestionIds);
    return filteredSuggestions;
  }

  getAdStrengthSuggestion({
    assetType,
    target,
    input,
    viewModel,
    isInitPicker,
  }) {
    const {
      appState, token, odataPath,
    } = this;

    const repository = new AdStrengthSuggestionRepository({
      viewModel,
      appState,
      token,
      odataPath,
    });

    const { adGroupId } = viewModel.scope();
    const finalUrl = !_.isEmpty(viewModel.FinalUrls()) ?
      _.first(viewModel.FinalUrls()) : null;

    if (isInitPicker && !this.isSuggestionCached(viewModel.scope().adGroupId, finalUrl)) {
      // When ad group id or final url is changed, need to get suggestion from MT again.
      repository.fetchAdStrengthSuggestion().then(({ data }) => {
        this.cachedAdGroupId = adGroupId;
        this.cachedFinalUrl = finalUrl;
        this.cachedSuggestions = []; // clean up cached suggestions
        if (!_.isEmpty(data)) {
          const {
            ErrorCode,
            RSAV2AssetsSuggestions,
          } = data;
          if (ErrorCode === 'Success' && !_.isEmpty(RSAV2AssetsSuggestions)) {
            this.cachedSuggestions = _.first(RSAV2AssetsSuggestions).Suggestions;
            const filteredSuggestions
              = this.filterSuggestion(viewModel, assetType, input);
            this.renderPicker(target, filteredSuggestions, viewModel, assetType);
          }
        }
      });
    } else {
      const filteredSuggestions
        = this.filterSuggestion(viewModel, assetType, input);
      this.renderPicker(target, filteredSuggestions, viewModel, assetType);
    }
  }
}
